import React, {Component} from "react"
import {Link} from "react-router"
import {Row, Col, Card, Form, FormField, FormInput, Button} from "elemental"
import {browserHistory} from "react-router"
import queryString from "query-string"
import "./Login.css"
import shop from "shop/shop"
import app from "app.controller"
import {translate} from "translate"

import config from "config"

export default class LoginPage extends Component {
  constructor() {
    super()
    this.state = {
      user:     "",
      password: ""
    }
    shop.whoami()
  }

  handleLogin = (e) => {
    shop.login( { ...this.state } )
      .catch( (err) => {
        console.error( err )
        shop.toast( translate("error.login_error"), "error" )
        return false
      } )
      .then( session => {
        if ( !session ) return

        const query = queryString.parse(document.location.search.slice(1))
        console.log("LOGIN WITH QUERY", query)
        shop.cart.get()
        shop.toast( `Willkommen ${session.value.title}` )
        if ( shop.stateAfterLogin ) {
          browserHistory.go( shop.stateAfterLogin )
        }
        if( query.referrer ){
          console.log("GOTO", query.referrer)
          browserHistory.push( query.referrer )
        }

        else {
          browserHistory.push( "/home" )
        }
      } )

    e.preventDefault()
  }

  handleUserChange = (event) => {
    this.setState( {
      user: event.target.value
    } )
  }

  handlePasswordChange = (event) => {
    this.setState( {
      password: event.target.value
    } )
  }

  render() {
    return (
      <div>
        <div className="pa3">
          <Link to="/home"><Button><i className="icon icon-home-1"/></Button></Link>

          <div className="fr">
            <Button onClick={() =>     app.language.changed.dispatch( "en-US" ) }>EN</Button> &nbsp;
            <Button onClick={() =>     app.language.changed.dispatch( "de-DE" ) }>DE</Button>
          </div>
        </div>

        <div className="container">

          <section>
            <Row>
              <Col className="text-center"
                   style={{ marginTop: "60px" }}>
                <Link to="/">
                  <img
                    src="/logo.png"
                    alt=""/>
                </Link>
              </Col>
            </Row>
          </section>

          <Row>
            <Col sm="4/12"> </Col>
            <Col sm="4/12">
              <Card style={{ marginTop: "60px" }}>
                <Form onSubmit={this.handleLogin}>
                  <FormField label={translate("shop.user")}
                             htmlFor="basic-form-input-email">
                    <FormInput value={this.state.user}
                               onChange={this.handleUserChange}
                               autoFocus
                               type="text"
                               placeholder="Benutzer-ID"
                               name="basic-form-input-id"/>
                  </FormField>
                  <FormField label={translate("shop.password")}
                             htmlFor="basic-form-input-password">
                    <FormInput value={this.state.password}
                               onChange={this.handlePasswordChange}
                               type="password"
                               placeholder="Passwort"
                               name="basic-form-input-password"/>
                  </FormField>
                  {/*<FormField>*/}
                  {/*<Checkbox label="Login speichern" />*/}
                  {/*</FormField>*/}
                  <div className="tc pt3">
                    <Button submit type="primary">{translate("shop.login")}</Button>
                    <Link className="db mt3" to="reset_password">{translate("shop.lost_password")}</Link>
                  </div>
                </Form>
              </Card>
            </Col>
          </Row>

          <hr/>

          <div className="tc">
            <div className="black-50">{translate("strings.new_account_hint")}</div>
            {config.customer_registration && <Link to="customer_registration">{translate("strings.new_account_action")}</Link>} <br/>
            {config.customer_enabling && <Link to="customer_enabling">{translate("strings.new_account_enabled")}</Link>}
          </div>

          {config.b2cLink && <div>
            <hr/>
            <div className="tc">
              <a href={config.b2cLink}>Shop für Privatkunden</a>
            </div>
          </div>}
        </div>
      </div>

    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/LoginPage.js